'use client'
import { RedocStandalone } from 'redoc';
import config from "@/tailwind.config";
import resolveConfig from "tailwindcss/resolveConfig";

const tw = resolveConfig(config).theme as {
  colors: {
    [key: string]: string
  },
  fontFamily: {
    main: string
    display: string
    mono: string[]
  }
}

export const ApiViewer = ({url}: {
  url: string,
}) => <div id="sectionNavigation"><RedocStandalone
  specUrl={url}
  options={{
    hideDownloadButton: true,
    hideHostname: true,
    theme: {
      colors: {
        primary: {
          main: tw.colors.navy['600'],
        },
        success: {
          main: tw.colors.teal['600'],
        },
        warning: {
          main: tw.colors.orange['600'],
        },
        error: {
          main: tw.colors.pink['600'],
        },
        text: {
          primary: tw.colors.navy['600'],
          secondary: tw.colors.gray['700']
        },
        http: {
          basic: tw.colors.gray['800'],
          delete: tw.colors.pink['800'],
          get: tw.colors.blue['600'],
          head: tw.colors.pink['600'],
          link: tw.colors.teal['700'],
          patch: tw.colors.orange['700'],
          options: tw.colors.orange['800'],
          post: tw.colors.blue['700'],
          put: tw.colors.pink['500'],
        }
      },
      typography: {
        fontFamily: tw.fontFamily.main,
        headings: {
          fontFamily: tw.fontFamily.display,
        },
        code: {
          fontFamily: tw.fontFamily.mono.join(', ')
        }
      },
      rightPanel: {
        backgroundColor: tw.colors.navy['700']
      }
    }
  }}
/></div>